import React from "react";
import loader from "./loading.gif";

const Loading = () => {
  return (
    <>
      <img src={loader} alt="loader" />
    </>
  );
};

export default Loading;
